import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowRight, MousePointerClick } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { EmptyState } from '../../../../../components/design-system/admin';
import { VIZ_LINKS } from '../links';

/**
 * A vendor with no visitors yet, in this period or the one before: not a bad
 * month, a visualizer that is not on their site. Say how the numbers start.
 */
export function NoTrafficState({ title, description }: { title?: ReactNode; description?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <Card className="py-2" data-testid="viz-no-traffic">
      <EmptyState
        icon={<MousePointerClick />}
        title={title ?? t('VIZ_ANALYTICS.EMPTY.TITLE')}
        description={description ?? t('VIZ_ANALYTICS.EMPTY.BODY')}
        action={
          <div className="flex flex-wrap justify-center gap-2">
            <Button asChild variant="outline" size="sm">
              <Link to={VIZ_LINKS.install}>
                {t('VIZ_ANALYTICS.EMPTY.INSTALL')}
                <ArrowRight className="rtl:rotate-180" data-icon="inline-end" />
              </Link>
            </Button>
            <Button asChild variant="ghost" size="sm">
              <Link to={VIZ_LINKS.catalog}>{t('VIZ_ANALYTICS.EMPTY.CATALOG')}</Link>
            </Button>
          </div>
        }
      />
    </Card>
  );
}
